import { render } from "./pages.vue?vue&type=template&id=334348e9&scoped=true&ts=true"
import script from "./pages.vue?vue&type=script&lang=ts"
export * from "./pages.vue?vue&type=script&lang=ts"

import "./pages.vue?vue&type=style&index=0&id=334348e9&scoped=true&lang=scss"

import exportComponent from "/builds/gh_devops/help_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334348e9"]])

export default __exports__